
// MMM 기준
export const standardWeight_Girder = [
    /* 순서의 기준
                                                     No-Deck                                                                           Deck
                           비중<1.0                1.0<비중<2.0                2.0<비중                     비중<1.0                1.0<비중<2.0                2.0<비중
                    ~10   ~15   ~20   20~     ~10   ~15   ~20   20~     ~10   ~15   ~20   20~      ~10    ~15   ~20    20~    ~10    ~15    ~20    20~    ~10    ~15    ~20    20~
        index No.    0     1     2     3       4     5     6     7       8     9     10    11       12     13    14     15     16     17     18     19     20     21     22     23
    */
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [95.1, 94.1, 104.0, 0, 95.1, 102.5, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 114.0, 146.9, 0, 95.1, 114.0, 162.4, 0],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [95.1, 94.1, 104.0, 0, 95.1, 102.5, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 114.0, 146.9, 0, 95.1, 114.0, 162.4, 0],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [95.1, 94.1, 104.0, 0, 95.1, 102.5, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 114.0, 146.9, 0, 95.1, 114.0, 162.4, 0],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [95.1, 94.1, 104.0, 0, 95.1, 102.5, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 104.0, 138.3, 0, 95.1, 114.0, 146.9, 0, 95.1, 114.0, 162.4, 0],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [95.9, 95.3, 109.0, 0, 95.9, 105.0, 139.1, 0, 95.9, 105.0, 139.1, 0, 95.9, 109.0, 139.1, 0, 95.9, 114.7, 147.5, 0, 95.9, 114.7, 164.3, 0],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [97.9, 97.0, 110.4, 0, 97.9, 106.6, 140.6, 0, 97.9, 106.6, 140.6, 0, 97.9, 110.4, 140.6, 0, 97.9, 116.4, 165.8, 0, 97.9, 119.6, 174.4, 0],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [99.1, 106.6, 118.0, 0, 99.1, 114.4, 145.6, 0, 99.1, 118.0, 147.4, 0, 99.1, 118.0, 145.6, 0, 99.1, 118.0, 179.5, 0, 113.3, 121.0, 179.5, 0],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [99.7, 107.1, 113.9, 0, 99.7, 113.9, 148.4, 0, 99.7, 118.2, 155.2, 0, 99.7, 113.9, 146.6, 0, 114.2, 121.8, 180.5, 0, 114.2, 147.9, 180.5, 0],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [102.1, 111.9, 121.8, 0, 102.1, 121.8, 157.6, 0, 102.1, 121.8, 162.4, 0, 102.1, 121.8, 149, 0, 118.9, 151.0, 182.8, 0, 118.9, 151.0, 202.4, 0],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [106.1, 120.8, 125.6, 0, 106.1, 128.8, 187.2, 0, 106.1, 128.8, 187.2, 0, 106.1, 125.6, 177.4, 0, 128.1, 154.9, 214.8, 0, 128.1, 160.8, 237.0, 0],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [121.2, 132.7, 136.2, 0, 133.4, 166.2, 206.6, 0, 133.4, 167.5, 211.9, 0, 133.4, 136.2, 195.7, 0, 142.9, 175.0, 262.7, 0, 144.4, 188.8, 280.5, 0],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [124.9, 137.2, 161.8, 0, 139.1, 175.0, 245.4, 0, 143.8, 175.0, 247.3, 0, 138.3, 161.8, 220.3, 0, 147.3, 186.0, 285.8, 0, 174.6, 204.7, 301.8, 0],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [130, 145, 170, 0, 145, 185, 260, 0, 150, 185, 260, 0, 150, 170, 230, 0, 155, 195, 300, 0, 185, 210, 310, 0],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [135, 150, 175, 0, 150, 190, 270, 0, 155, 190, 270, 0, 155, 175, 240, 0, 160, 200, 310, 0, 190, 215, 320, 0],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [140, 155, 180, 0, 155, 195, 280, 0, 160, 195, 280, 0, 160, 180, 250, 0, 165, 205, 320, 0, 195, 220, 330, 0],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [140, 155, 180, 0, 155, 195, 280, 0, 160, 195, 280, 0, 160, 180, 250, 0, 165, 205, 320, 0, 195, 220, 330, 0],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [140, 155, 180, 0, 155, 195, 280, 0, 160, 195, 280, 0, 160, 180, 250, 0, 165, 205, 320, 0, 195, 220, 330, 0],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [140, 155, 180, 0, 155, 195, 280, 0, 160, 195, 280, 0, 160, 180, 250, 0, 165, 205, 320, 0, 195, 220, 330, 0],
    },
];

export const standardWeight_PCGirder = [
    {
        id: 1,
        beltWidth: 600,
        //                 Deck Plate 무                                        Deck Plate 유
        //  S<6, 6<=S<10, 10<=S<15, 15<=S<20, 20<=S<25, 25<=S, 0<S<=6, 6<S<=10, 10<S<=15, 15<S<=20, 20<S<=25, 25<S 
        //               0   1   2   3    4    5   6   7   8   9    10  11
        standardWeight: [73, 65, 69, 93, 136, 216, 73, 65, 64, 93, 126, 191],
    },
    {
        id: 2,
        beltWidth: 750,
        standardWeight: [71, 68, 65, 91, 131, 186, 71, 68, 68, 91, 140, 186],
    },
    {
        id: 3,
        beltWidth: 900,
        standardWeight: [68, 67, 74, 88, 129, 150, 68, 67, 74, 88, 130, 171],
    },
    {
        id: 4,
        beltWidth: 1050,
        standardWeight: [71, 66, 74, 99, 115, 148, 71, 66, 73, 99, 135, 148],
    },
    {
        id: 5,
        beltWidth: 1200,
        standardWeight: [77, 70, 74, 100, 117, 160, 77, 75, 74, 101, 137, 173],
    },
    {
        id: 6,
        beltWidth: 1400,
        standardWeight: [81, 75, 76, 102, 105, 162, 84, 75, 78, 104, 128, 183],
    },
    {
        id: 7,
        beltWidth: 1600,
        standardWeight: [84, 77, 78, 106, 107, 153, 86, 77, 81, 106, 131, 191],
    },
    {
        id: 8,
        beltWidth: 1800,
        standardWeight: [92, 84, 88, 112, 126, 168, 95, 89, 101, 120, 126, 193],
    },
    {
        id: 9,
        beltWidth: 2000,
        standardWeight: [98, 92, 90, 115, 140, 173, 98, 99, 104, 123, 152, 197],
    },
    {
        id: 10,
        beltWidth: 2200,
        standardWeight: [88, 78, 80, 106, 132, 184, 88, 87, 94, 114, 151, 212],
    },
    {
        id: 11,
        beltWidth: 2400,
        standardWeight: [119, 112, 117, 141, 159, 205, 124, 118, 129, 155, 182, 246],
    },
    {
        id: 12,
        beltWidth: 2600,
        standardWeight: [125, 120, 124, 146, 164, 219, 128, 127, 146, 156, 188, 259],
    },
    {
        id: 13,
        beltWidth: 2800,
        standardWeight: [128, 124, 130, 159, 170, 232, 133, 137, 148, 165, 195, 268],
    },
    {
        id: 14,
        beltWidth: 3000,
        standardWeight: [134, 134, 151, 170, 194, 239, 140, 140, 164, 171, 210, 275],
    },
];

export const standardWeight_PCPanel = [
    {
        id: 1,
        beltWidth: 600,
        // 롤러브라켓, 하프판넬
        standardWeight: [8, 9],
    },
    {
        id: 2,
        beltWidth: 750,
        standardWeight: [8.41, 10],
    },
    {
        id: 3,
        beltWidth: 900,
        standardWeight: [8.5, 11],
    },
    {
        id: 4,
        beltWidth: 1050,
        standardWeight: [9.5, 12],
    },
    {
        id: 5,
        beltWidth: 1200,
        standardWeight: [13.7, 21],
    },
    {
        id: 6,
        beltWidth: 1400,
        standardWeight: [13.7, 24],
    },
    {
        id: 7,
        beltWidth: 1600,
        standardWeight: [16.8, 28],
    },
    {
        id: 8,
        beltWidth: 1800,
        standardWeight: [28.21, 38],
    },
    {
        id: 9,
        beltWidth: 2000,
        standardWeight: [28.21, 60],
    },
    {
        id: 10,
        beltWidth: 2200,
        standardWeight: [32, 71],
    },
    {
        id: 11,
        beltWidth: 2400,
        standardWeight: [41.5, 82],
    },
    {
        id: 12,
        beltWidth: 2600,
        standardWeight: [41.5, 86],
    },
    {
        id: 13,
        beltWidth: 2800,
        standardWeight: [41.5, 91],
    },
    {
        id: 14,
        beltWidth: 3000,
        standardWeight: [45.6, 116],
    },
]

export const standardWeight_Gallery = [

]

export const standardWeight_Trestle = [
    /* H<=5  5<H<=10  10<H<=15  15<H<=20  20<H<=25 */
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [325, 350],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [325, 350],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [325, 350],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [325, 350],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [325, 350],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [320, 350],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [320, 350],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [320, 350],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [108.2, 125.8, 156.6, 196.3, 358.7],
        columnHead: [320, 350],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [114, 130, 161.8, 201.5, 364.6],
        columnHead: [385, 405],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [114, 130, 161.8, 201.5, 364.6],
        columnHead: [375, 400],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [114, 130, 161.8, 201.5, 364.6],
        columnHead: [370, 395],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [122.4, 133.9, 169.2, 206.6, 371.0],
        columnHead: [380, 400],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [122.4, 133.9, 169.2, 206.6, 371.0],
        columnHead: [380, 400],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [122.4, 133.9, 169.2, 206.6, 371.0],
        columnHead: [380, 400],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [122.4, 133.9, 169.2, 206.6, 371.0],
        columnHead: [380, 400],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [122.4, 133.9, 169.2, 206.6, 371.0],
        columnHead: [380, 400],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [122.4, 133.9, 169.2, 206.6, 371.0],
        columnHead: [380, 400],
    },
];

export const standardWeight_Stringer = [
    {
        id: 0,
        beltWidth: 400,
        standardWeight: [25, 25, 25],
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [25, 25, 25],
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [25, 25, 25],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [25, 25, 25],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [25, 25, 25],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [25, 25, 27],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [25, 25, 27],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [25, 25, 27],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [26, 26, 35],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [26, 26, 36],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [28, 36, 47],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [37, 37, 47],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [37, 37, 47],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [49, 49, 54],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [47, 49, 61],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [60, 60, 76],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [62, 62, 78],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [62, 62, 78],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [62, 62, 78],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [62, 62, 78],
    },
];

export const standardWeight_Walkway = [
    /*
                sinlge-side                       Both Side                      Dual Parallel
        Grating, Checkered, Expanded,   Grating, Checkered, Expanded,   Grating, Checkered, Expanded
    */
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [101, 102, 103, 104, 105, 106, 107, 108, 109],
    },
];

export const standardWeight_Skirtboard = [
    {
        id: 0,
        beltWidth: 400,
        standardWeight: 68,
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: 68,
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: 72,
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: 78,
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: 78,
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: 83,
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: 87,
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: 87,
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: 91,
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: 91,
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: 96,
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: 142,
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: 147,
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: 160,
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: 164,
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: 178,
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: 192,
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: 192,
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: 192,
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: 192,
    },
];

export const standardWeight_HeadFrame = [
    /* P<=2.0, 2.0<P<=5.0, 5.0<P<=10, 10<P<=15, 15<P */
    /* 여기서 P는 축수부하중 즉, Resultant Force로 판단된다. 확인 필요. '24.3/12 */
    {
        id: 0,
        beltWidth: 400,
        standardWeight: [160, 160, 180, undefined, undefined],
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [160, 160, 180, undefined, undefined],
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [180, 180, 200, undefined, undefined],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [200, 200, 220, undefined, undefined],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [200, 240, 220, undefined, undefined],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [240, 240, 280, undefined, undefined],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [250, 250, 300, undefined, undefined],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [260, 320, 360, 450, undefined],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [280, 360, 400, 500, undefined],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [280, 360, 400, 550, undefined],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [300, 410, 450, 600, undefined],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [320, 430, 500, 650, 800],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [340, 460, 600, 700, 950],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [360, 480, 650, 750, 900],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [380, 500, 680, 800, 950],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [400, 530, 700, 850, 1000],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [420, 560, 730, 900, 1050],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [420, 560, 730, 900, 1050],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [420, 560, 730, 900, 1050],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [420, 560, 730, 900, 1050],
    },
];

export const standardWeight_TailFrame = [
    /* P<=1.4, 1.4<P<=2.3, 2.3<P<=3.6, 3.6<P<=4.5, 4.5<P<=5.7, 5.7<P<=7.2, 7.2<P */
    /* 여기서 P는 축수부하중 즉, Resultant Force로 판단된다. 확인 필요. '24.3/12 */
    {
        id: 0,
        beltWidth: 400,
        standardWeight: [80, 115, 150, 170, 180, undefined, undefined],
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [85, 120, 150, 170, 180, undefined, undefined],
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [90, 125, 160, 180, 190, undefined, undefined],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [95, 130, 170, 190, 200, undefined, undefined],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [100, 130, 170, 190, 200, undefined, undefined],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [105, 140, 180, 200, 210, 300, 330],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [105, 140, 180, 200, 210, 300, 350],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [110, 150, 190, 210, 230, 310, 370],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [115, 160, 190, 210, 240, 330, 390],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [115, 170, 200, 220, 250, 330, 390],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [120, 180, 210, 230, 260, 350, 410],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [125, 200, 230, 250, 280, 370, 430],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [undefined, 230, 250, 270, 300, 390, 450],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [undefined, undefined, 270, 290, 320, 410, 470],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [undefined, undefined, 290, 310, 340, 430, 490],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [undefined, undefined, 310, 330, 360, 450, 510],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [undefined, undefined, 330, 350, 390, 470, 530],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [undefined, undefined, 330, 350, 390, 470, 530],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [undefined, undefined, 330, 350, 390, 470, 530],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [undefined, undefined, 330, 350, 390, 470, 530],
    },
];

export const standardWeight_CommonBed = [
    {
        id: 0,
        standardPower: 30,
        standardWeight: 230, 
    },
    {
        id: 1,
        standardPower: 37,
        standardWeight: 250, 
    },
    {
        id: 2,
        standardPower: 45,
        standardWeight: 300, 
    },
    {
        id: 3,
        standardPower: 55,
        standardWeight: 330, 
    },
    {
        id: 4,
        standardPower: 75,
        standardWeight: 400, 
    },
    {
        id: 5,
        standardPower: 90,
        standardWeight: 450, 
    },
    {
        id: 6,
        standardPower: 110,
        standardWeight: 500, 
    },
    {
        id: 7,
        standardPower: 132,
        standardWeight: 600, 
    },
    {
        id: 8,
        standardPower: 150,
        standardWeight: 650, 
    },
    {
        id: 9,
        standardPower: 160,
        standardWeight: 700, 
    },
    {
        id: 10,
        standardPower: 185,
        standardWeight: 800, 
    },
    {
        id: 11,
        standardPower: 200,
        standardWeight: 900, 
    },
    {
        id: 12,
        standardPower: 220,
        standardWeight: 1000, 
    },
    {
        id: 13,
        standardPower: 250,
        standardWeight: 1200, 
    },
    {
        id: 14,
        standardPower: 280,
        standardWeight: 1350, 
    },
    {
        id: 15,
        standardPower: 300,
        standardWeight: 1500, 
    },
    {
        id: 16,
        standardPower: 400,
        standardWeight: 1800, 
    },
    {
        id: 17,
        standardPower: 500,
        standardWeight: 2000, 
    },
    {
        id: 18,
        standardPower: 600,
        standardWeight: 2300, 
    },
    {
        id: 19,
        standardPower: 800,
        standardWeight: 2600, 
    },
    {
        id: 20,
        standardPower: Infinity,
        standardWeight: 3000,
    }
];

export const standardWeight_GearedMotorBed = [
    {
        id: 0,
        standardPower: 3.7,
        standardWeight: 90,
    },
    {
        id: 1,
        standardPower: 5.5,
        standardWeight: 120,
    },
    {
        id: 2,
        standardPower: 7.5,
        standardWeight: 130,
    },
    {
        id: 3,
        standardPower: 11,
        standardWeight: 130,
    },
    {
        id: 4,
        standardPower: 15,
        standardWeight: 140,
    },
    {
        id: 5,
        standardPower: 18.5,
        standardWeight: 140,
    },
    {
        id: 6,
        standardPower: 22,
        standardWeight: 150,
    },
    {
        id: 7,
        standardPower: 30,
        standardWeight: 180,
    },
    {
        id: 8,
        standardPower: 37,
        standardWeight: 280,
    },
    {
        id: 9,
        standardPower: 45,
        standardWeight: 300,
    },
    {
        id: 10,
        standardPower: 55,
        standardWeight: 330,
    },
];

export const standardWeight_Takeup = [
    {
        id: 0,
        beltWidth: 400,
        /* T2<=1.4, 1.4<T2<=2.3, 2.3<T2<=3.6, 3.6<T2<=4.5, 4.5<T2<=5.7, 5.7<T2<=7.2, 7.2<T2<=9.9, 9.9<T2   */
        /* 9.9<T2 MMM 기준은 없으나 7.2<T2<=9.9의 값을 복사하여 사용함. */
        weightBoxVertical: [400, 540, 740, undefined, undefined, undefined, undefined, undefined],  // 벨트폭에 따라 다름
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],  // 벨트폭 무관 동일함.
        tower: [    // 벨트폭 무관 동일함
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],   // 8m 이하
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],   // 8m 초과 12m 이하
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],   // 12m 초과 15m 이하
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],   // 15m 초과. MMM 기준이 없어서 15m 이하와 동일한 데이터를 적용함.
        ],
        truck: [250, 250, 300, 390, undefined, undefined, undefined, undefined],  // 벨트폭에 따라 다름
        // 로프 장력에 따른 wireRope의 m당 중량 [2.8톤 이하, 4.6, 7.2, 9.0, 11.4, 14.4, 20.0, 20.0초과]
        // MMM 기준은 잘못되어 있는 듯함. wireRope의 m당 중량을 전체 중량에 그냥 합산되어 있음. 20m 기준으로 wireRope 중량을 추정하자.
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        // 로프 장력 [2.8이하, 4.6, 7.2, 9.0, 11.4, 14.4, 20.0, 20.0초과] <- T2 텐션과 동일한 값
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 1,
        beltWidth: 450,
        weightBoxVertical: [400, 540, 740, undefined, undefined, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [250, 250, 300, 390, undefined, undefined, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]


    },
    {
        id: 2,
        beltWidth: 500,
        weightBoxVertical: [400, 540, 740, undefined, undefined, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [250, 250, 300, 390, undefined, undefined, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 3,
        beltWidth: 600,
        weightBoxVertical: [400, 540, 740, undefined, undefined, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [270, 270, 320, 420, undefined, undefined, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 4,
        beltWidth: 650,
        weightBoxVertical: [400, 540, 740, undefined, undefined, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [270, 270, 320, 420, undefined, undefined, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 5,
        beltWidth: 750,
        weightBoxVertical: [430, 520, 690, 810, undefined, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [270, 270, 320, 420, undefined, undefined, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 6,
        beltWidth: 800,
        weightBoxVertical: [430, 520, 690, 810, undefined, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [280, 280, 340, 430, 440, undefined, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 7,
        beltWidth: 900,
        weightBoxVertical: [430, 520, 690, 810, undefined, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [280, 280, 340, 430, 440, undefined, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 8,
        beltWidth: 1000,
        weightBoxVertical: [480, 530, 690, 790, 940, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [290, 290, 350, 460, 460, 490, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 9,
        beltWidth: 1050,
        weightBoxVertical: [480, 530, 690, 790, 940, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [290, 290, 350, 460, 460, 490, undefined, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 10,
        beltWidth: 1200,
        weightBoxVertical: [480, 530, 690, 790, 940, undefined, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [320, 330, 400, 470, 510, 620, 820, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 11,
        beltWidth: 1400,
        weightBoxVertical: [550, 550, 740, 790, 960, 1230, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [320, 330, 400, 470, 510, 620, 820, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 12,
        beltWidth: 1600,
        weightBoxVertical: [550, 550, 740, 790, 960, 1230, undefined, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [350, 360, 430, 520, 550, 660, 880, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 13,
        beltWidth: 1800,
        weightBoxVertical: [580, 580, 640, 750, 870, 1140, 1450, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [350, 360, 430, 520, 550, 660, 880, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 14,
        beltWidth: 2000,
        weightBoxVertical: [580, 580, 640, 750, 870, 1140, 1450, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [380, 430, 500, 580, 630, 730, 960, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 15,
        beltWidth: 2200,
        weightBoxVertical: [740, 740, 740, 830, 950, 1240, 1570, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [380, 430, 500, 580, 630, 730, 960, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 16,
        beltWidth: 2400,
        weightBoxVertical: [740, 740, 740, 830, 950, 1240, 1570, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [430, 550, 640, 680, 770, 870, 1100, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 17,
        beltWidth: 2600,
        weightBoxVertical: [740, 740, 740, 830, 950, 1240, 1570, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [430, 550, 640, 680, 770, 870, 1100, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 18,
        beltWidth: 2800,
        weightBoxVertical: [740, 740, 740, 830, 950, 1240, 1570, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [430, 550, 640, 680, 770, 870, 1100, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
    {
        id: 19,
        beltWidth: 3000,
        weightBoxVertical: [740, 740, 740, 830, 950, 1240, 1570, undefined],
        weightBoxHorizontal: [1240, 1240, 1660, 2090, 2090, 2520, 2930, 2930],
        tower: [
            [2000, 2100, 2600, 3300, 3400, 4000, 4700, 4700],
            [2500, 2600, 3000, 4000, 4200, 4800, 5500, 5500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
            [3000, 3600, 4700, 4800, 5500, 6200, 6500, 6500],
        ],
        truck: [430, 550, 640, 680, 770, 870, 1100, undefined],
        wire: [1.13, 1.76, 2.75, 3.45, 4.37, 5.55, 7.95, 7.95],
        sheaveBracket: [135, 135, 192, 259, 259, 326, 375, 375]
    },
];

export const standardWeight_Tripper = [
    {
        id: 0,
        beltWidth: 400,
        standardWeight: 1460,
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: 1510,
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: 1590,
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: 1610,
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: 1650,
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: 1940,
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: 2130,
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: 2250,
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: 2880,
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: 3060,
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: 3820,
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: 4220,
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: 5230,
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: 5650,
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: 6380,
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: 7130,
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: 7760,
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: 7760,
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: 7760,
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: 7760,
    },
]


export const standardWeight_Shuttle = [
    {
        id: 0,
        beltWidth: 400,
        // [10m 이하, 20m 이하, 20m 초과, 구동WheelAssyWeight/set, 구동WheelPlummerBlock, 종동WheelAssyWeight/set, 종동WheelPlummerBlock]
        standardWeight: [288, 198, 167, 213, 'SN522', 200, 'SN522'],
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [288, 198, 167, 213, 'SN522', 200, 'SN522'],
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [288, 198, 167, 213, 'SN522', 200, 'SN522'],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [288, 198, 167, 213, 'SN522', 200, 'SN522'],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [288, 198, 167, 213, 'SN522', 200, 'SN522'],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [322, 214, 177, 239, 'SN522', 226, 'SN522'],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [322, 214, 177, 239, 'SN522', 226, 'SN522'],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [322, 214, 177, 239, 'SN522', 226, 'SN522'],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [418, 266, 221, 545, 'SD3136', 522, 'SD3136'],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [418, 266, 221, 545, 'SD3136', 522, 'SD3136'],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [418, 266, 221, 545, 'SD3136', 522, 'SD3136'],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [480, 295, 256, 625, 'SD3136', 602, 'SD3136'],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [480, 295, 256, 625, 'SD3136', 602, 'SD3136'],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [596, 385, 328, 743, 'SD3136', 722, 'SD3136'],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [596, 385, 328, 743, 'SD3136', 722, 'SD3136'],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [688, 440, 372, 825, 'SD3136', 802, 'SD3136'],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [688, 440, 372, 825, 'SD3136', 802, 'SD3136'],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [688, 440, 372, 825, 'SD3136', 802, 'SD3136'],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [688, 440, 372, 825, 'SD3136', 802, 'SD3136'],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [688, 440, 372, 825, 'SD3136', 802, 'SD3136'],
    },
];

export const standardWeight_WheelAssy = [
    {
        id: 0,
        beltWidth: 400,
        // Drive, Non-Drive
        standardWeight: [213, 200],
        // Drive, Non-Drive
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [213, 200],
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [213, 200],
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [213, 200],
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [213, 200],
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [239, 226],
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [239, 226],
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [239, 226],
        plummerBlock: ['SN522', 'SN522']
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [545, 522],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [545, 522],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [545, 522],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [625, 602],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [625, 602],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [743, 722],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [743, 722],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [825, 802],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [825, 802],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [825, 802],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [825, 802],
        plummerBlock: ['SD3136', 'SD3136']
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [825, 802],
        plummerBlock: ['SD3136', 'SD3136']
    },
]

export const standardWeight_Rail = [
    {
        id: 0,
        type: '6',  // Rail type
        standardWeight: 5.98,   // kg/m
    },
    {
        id: 1,
        type: '9',
        standardWeight: 8.94,
    },
    {
        id: 2,
        type: '10',
        standardWeight: 10.1,
    },
    {
        id: 3,
        type: '12',
        standardWeight: 12.2,
    },
    {
        id: 4,
        type: '15',
        standardWeight: 15.2,
    },
    {
        id: 5,
        type: '22',
        standardWeight: 22.3,
    },
    {
        id: 6,
        type: '30A',
        standardWeight: 30.1,
    },
    {
        id: 7,
        type: '37A',
        standardWeight: 37.2,
    },
    {
        id: 8,
        type: '40N',
        standardWeight: 40.9,
    },
    {
        id: 9,
        type: '50N',
        standardWeight: 50.4,
    },
    {
        id: 10,
        type: '60',
        standardWeight: 60.8,
    },
];

export const standardWeight_Chute = [
    {
        id: 0,
        beltWidth: 400,
        // [3m, 4m, 5m]
        standardWeight: [380, 450, 520],
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [410, 500, 580],
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [430, 530, 630],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [480, 640, 840],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [520, 700, 920],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [590, 740, 1040],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [620, 800, 1080],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [700, 900, 1150],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [780, 1050, 1350],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [850, 1150, 1460],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [950, 1350, 1650],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [1020, 1570, 1870],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [1200, 1700, 2000],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [1380, 1830, 2130],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [1550, 1900, 2250],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [1740, 2000, 2380],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [1950, 2100, 2500],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [1950, 2100, 2500],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [1950, 2100, 2500],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [1950, 2100, 2500],
    },

];

export const standardWeight_Damper = [
    {
        id: 0,
        beltWidth: 400,
        // [stonebox-diverting, stonebox-adjust, straight-diverting, straight-adjust]
        standardWeight: [150, 200, 120, 80]
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [150, 200, 120, 80],
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [150, 200, 120, 80],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [200, 280, 180, 110],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [200, 280, 180, 110],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [200, 280, 180, 110],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [200, 280, 180, 110],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [300, 350, 250, 160],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [300, 350, 250, 160],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [300, 350, 250, 160],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [300, 350, 250, 160],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [400, 450, 320, 200],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [400, 450, 320, 200],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [500, 550, 400, 250],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [500, 550, 400, 250],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [600, 650, 550, 300],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [600, 650, 550, 300],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [600, 650, 550, 300],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [600, 650, 550, 300],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [600, 650, 550, 300],
    },
];

export const standardWeight_Overbridge = [
    {
        id: 0,
        beltWidth: 400,
        standardWeight: 205,
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: 207,
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: 210,
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: 215,
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: 220,
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: 225,
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: 230,
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: 235,
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: 245,
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: 250,
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: 260,
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: 270,
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: 285,
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: 300,
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: 315,
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: 360,
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: 380,
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: 390,
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: 405,
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: 420,
    },
];


export const standardWeight_InternalBeltCleaner = [
    {
        id: 0,
        beltWidth: 400,
        // [V-Type, I-Type]
        standardWeight: [18, 15],
    },
    {
        id: 1,
        beltWidth: 450,
        standardWeight: [20, 15],
    },
    {
        id: 2,
        beltWidth: 500,
        standardWeight: [21, 15],
    },
    {
        id: 3,
        beltWidth: 600,
        standardWeight: [23, 17],
    },
    {
        id: 4,
        beltWidth: 650,
        standardWeight: [25, 18],
    },
    {
        id: 5,
        beltWidth: 750,
        standardWeight: [28, 20],
    },
    {
        id: 6,
        beltWidth: 800,
        standardWeight: [28, 20],
    },
    {
        id: 7,
        beltWidth: 900,
        standardWeight: [30, 23],
    },
    {
        id: 8,
        beltWidth: 1000,
        standardWeight: [34, 25],
    },
    {
        id: 9,
        beltWidth: 1050,
        standardWeight: [37, 36],
    },
    {
        id: 10,
        beltWidth: 1200,
        standardWeight: [56, 41],
    },
    {
        id: 11,
        beltWidth: 1400,
        standardWeight: [62, 46],
    },
    {
        id: 12,
        beltWidth: 1600,
        standardWeight: [69, 50],
    },
    {
        id: 13,
        beltWidth: 1800,
        standardWeight: [71, 58],
    },
    {
        id: 14,
        beltWidth: 2000,
        standardWeight: [76, 64],
    },
    {
        id: 15,
        beltWidth: 2200,
        standardWeight: [100, 70],
    },
    {
        id: 16,
        beltWidth: 2400,
        standardWeight: [115, 77],
    },
    {
        id: 17,
        beltWidth: 2600,
        standardWeight: [115, 77],
    },
    {
        id: 18,
        beltWidth: 2800,
        standardWeight: [115, 77],
    },
    {
        id: 19,
        beltWidth: 3000,
        standardWeight: [115, 77],
    },
];
